const HandlerCalculate  = require ('./purchase-fullcont-calculate-handler')


export function otherFieldProvider( detail, htmlFc ){  //console.log('updateCsutomerField -> ', htmlFc)

    var rawFields = htmlFc.fullcontHTML.querySelector('#purchase_form_provider_id').querySelector(".otherField").getAttribute('otherField');

    try {
      var purchaseOtherField = JSON.parse(rawFields);
      // console.log(purchaseOtherField);
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
    htmlFc.fullcontHTML.querySelector('#purchase_form_email input').value = purchaseOtherField.email;
}

export function otherFieldInvestor( detail, htmlFc ){  //console.log('updateCsutomerField -> ', htmlFc)

  var rawFields = htmlFc.fullcontHTML.querySelector('#purchase_form_provider_id');

  try {
    var customerOtherField = JSON.parse(rawFields);
    //console.log(customerOtherField);
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

  // htmlFc.fullcontHTML.querySelector('#sale_form_bill_to_address input').value = customerOtherField.address;
}

export function otherFieldItem(detail, htmlFc) {
  // console.log('updateItemField -> ', detail)

  let ac_line = htmlFc.fullcontHTML.querySelector("#purchase_form_item_selling_" + detail.id_ac + " input");
  ac_line.focus();
  ac_line.click();
}


// llenar los demas campos cuando se seleccione un item 
export function otherFieldItemLost(detail, htmlFc) {

  setTimeout(() => {
    let chipCont_label = detail.ev.target.closest('.textfield').querySelector('.chip-cont label');
    let line = detail.ev.target.closest('.line');
    let input_item = line.querySelector('.purchase_vs_itemId');
    let itemOtherField = get_otherField(input_item);
  
    let qty_available = HandlerCalculate.getQtyAvailable(itemOtherField.purchase_vs_itemId);
  
    // colocar la existencia del articulo junto a la descripcion
    chipCont_label.textContent += ' - ' +  qty_available;
  
  
    line.querySelector('.lost_price input').value =  "";
    line.querySelector('.lost_qty input').value = "";
    line.querySelector('.lost_qty input').focus();
  }, 100);

}

// traer el valor del otherfield de un autocomplete
export function get_otherField(ac_line) {

  try {

    let rawFields = ac_line.querySelector(".otherField");

    if (rawFields == null) {
      throw "Null";
    }

    return JSON.parse(rawFields.getAttribute('otherField'));

  } catch (error) {
    console.error("Error parsing JSON:", error);
  }
}
